(function ($) {
    "use strict";

    $(function () {
        $(".js-dropdown-button").on("click", function (e) {
            e.preventDefault();
            $(".js-dropdown-button").removeClass("is-open");
            $(this).addClass("is-open");
        });

        $(".js-dropdown-button [data-dropdown-value]").on("click", function (e) {
            e.preventDefault();
            var $item = $(this);
            var $dropdown = $item.parents(".js-dropdown-button");
            $dropdown.find(".js-dropdown-button__input").val($item.data("dropdown-value"));
            $dropdown.find(".js-dropdown-button__current").text($item.text());
        });

        $("body").on("click", function (e) {
            var $target = $(e.target);
            if (!$target.parents().hasClass("js-dropdown-button")) {
                $(".js-dropdown-button").removeClass("is-open");
            }
        });
    });
})(jQuery);
